import { render, staticRenderFns } from "./videoPersonalDetails.vue?vue&type=template&id=1da917d4&scoped=true&"
import script from "./videoPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./videoPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./videoPersonalDetails.vue?vue&type=style&index=0&id=1da917d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da917d4",
  null
  
)

export default component.exports